import request from 'lib/request'
import { APP_ENV } from '../../config'
import { restUrl } from 'lib/path-helpers'

/**
 * Supported types of app-crashes
 */
export const TRANSACTIONAL_CRASH = 'transactional'
export const JAVASCRIPT_CRASH = 'javascript'
export const GRAPHQL_CRASH = 'graphql'
export const SLOTH_CRASH = 'sloth-of-death'

interface AppCrashArgs {
  // a component associated with the crash
  componentName?: string
  // the current page's route
  route: string | null
  // the type of crash, one of ['transactional','javascript','graphql','sloth-of-death']
  type: string
  // the team associated with the part of the app that crashed
  team: string
}

/**
 * Capture crash metrics via gateway-api's `app-crash` rest endpoint
 */
export function trackAppCrash({
  componentName,
  route,
  type,
  team
}: AppCrashArgs) {
  return request(`${restUrl()}/stats/app-crash/${type}`, {
    method: 'POST',
    body: JSON.stringify({
      env: APP_ENV,
      componentName,
      route,
      team
    })
  }).catch(error => console.error(error)) // Catch network errors
}

interface AppPerformanceArgs {
  // the value of the metric
  duration: number
  // the name of the event/metric
  event: string
  // the current page's route
  route: string | null
  // the team that owns the current route
  team?: string
  // the react component name
  componentName?: string
}

/**
 * Capture performance metrics via gateway-api's `performance` rest endpoint
 */
export function trackAppPerformance({
  duration,
  event,
  route,
  team,
  componentName
}: AppPerformanceArgs) {
  return request(`${restUrl()}/stats/performance`, {
    method: 'POST',
    body: JSON.stringify({
      duration,
      env: APP_ENV,
      event,
      route,
      team,
      componentName
    })
  }).catch(error => console.error(error))
}
